import { Icon } from '@cfa/react-components';

const TeamSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width='24'
    height='24'
    fill="none"
    stroke="currentColor"
    strokeWidth="2"

  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /><path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
  </svg>
);

const TeamIcon = () => (
  <Icon icon={TeamSvg} />
);

export default TeamIcon;
